import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import Divider from '@mui/material/Divider';
import ReactPlayer from 'react-player/lazy';

const ModalContentStyle = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  borderRadius: 1,
  px: 3,
  py: 2,
  overflow: 'auto',
};

const closeIconStyle = { color: '#98A2AE', cursor: 'pointer' };

export function ModalVideoViewer(props: { open: boolean; onClose: () => void; title: string; videoURL: string }) {
  const handleCloseModal = () => {
    props.onClose();
  };
  return (
    <>
      <div>
        <Modal open={props.open} sx={{ zIndex: 1000 }}>
          <Stack>
            <Stack direction='column' sx={ModalContentStyle} spacing={2}>
              <Stack direction='column'>
                <Stack justifyContent='space-between' direction='row' alignItems='center'>
                  <Typography variant='body1' component='h2' fontWeight='bold' sx={{ color: '#3B4797' }}>
                    {props.title}
                  </Typography>
                  <IconButton onClick={handleCloseModal} component='label'>
                    <HighlightOffRoundedIcon sx={closeIconStyle} />
                  </IconButton>
                </Stack>
                <Divider sx={{ mb: 0 }} />
              </Stack>
              <Stack maxHeight='100vh' overflow='auto'>
                <ReactPlayer
                  url={props.videoURL}
                  width='100%'
                  height='100%'
                  controls
                  playing
                  volume={0.6}
                  config={{
                    youtube: {
                      embedOptions: { autoplay: 1, height: 400 },
                    },
                  }}
                />
              </Stack>
            </Stack>
          </Stack>
        </Modal>
      </div>
    </>
  );
}
